module.exports = __webpack_public_path__ + "img/new_friend.a5b1d929.png";